import {Pipe, PipeTransform} from '@angular/core';
import {Backend} from '@generated-backend-types';
import TableConfigColumn = Backend.App.Resources.Dashboard.Meta.TableConfigColumn;

@Pipe({
  name: 'shouldShowColumn',
  standalone: true
})
export class ShouldShowColumnPipe implements PipeTransform {
  transform(
    col: TableConfigColumn,
    hiddenColumns: string | undefined | null
  ): boolean {
    let isInHiddenColumns = false;

    // If the hiddenColumn Array is not undefined, we check it
    if (hiddenColumns !== undefined && hiddenColumns !== null) {
      const hiddenColumnsArray = hiddenColumns.split(',');
      for (let i = 0; i < hiddenColumnsArray.length; i++) {
        // We check if our searched item is in the array, and if it is, we cancel the for loop early and
        // flag the column as being found in the hiddenColumn array
        // Reason why not indexOf() or includes(): indexOf() is slow and includes() only does == comparisons, not === comparisons
        if (hiddenColumnsArray[i] === col.name) {
          isInHiddenColumns = true
          break;
        }
      }
    }

    return !isInHiddenColumns && col.visible;
  }
}
